module.exports = __webpack_public_path__ + "static/img/RU02.fab1ad0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/RU02.jpg
// module id = ObH2
// module chunks = 1